import { render, staticRenderFns } from "./package-item-detail.vue?vue&type=template&id=6e0657b1"
import script from "./package-item-detail.vue?vue&type=script&lang=js"
export * from "./package-item-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports